import { Component } from '@angular/core';

@Component({
  selector: 'apm-app-startup-loader',
  templateUrl: './app-startup-loader.component.html',
  styleUrl: './app-startup-loader.component.scss',
  standalone: false,
})
export class AppStartupLoaderComponent {}
